import { useState } from "react";
import type { FormEvent } from "react";
import { api, ApiError } from "@/api/client";
import { useSession } from "@/state/session";

/** The web half of the Roku device-code pairing flow. */
export function LinkDevice() {
  const { account } = useSession();
  const [code, setCode] = useState("");
  const [status, setStatus] = useState<"idle" | "done" | "error">("idle");
  const [message, setMessage] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    try {
      await api.post("/api/v1/auth/device/claim", { user_code: code.trim().toUpperCase() });
      setStatus("done");
    } catch (cause) {
      setStatus("error");
      setMessage(cause instanceof ApiError ? cause.message : "That code could not be used");
    }
  }

  return (
    <main className="page container" style={{ display: "grid", placeItems: "center" }}>
      <div className="panel panel--narrow" style={{ marginTop: 80, textAlign: "center" }}>
        <h1 style={{ marginBottom: 10 }}>Connect a TV</h1>
        {!account && (
          <p style={{ color: "var(--paper-400)" }}>Sign in first, then enter the code.</p>
        )}
        {status === "done" ? (
          <div className="alert alert--info">
            Your TV is connected. It should sign in within a few seconds.
          </div>
        ) : (
          <form onSubmit={submit}>
            {status === "error" && <div className="alert alert--error">{message}</div>}
            <div className="field">
              <label htmlFor="code">Code shown on your TV</label>
              <input
                id="code"
                value={code}
                onChange={(event) => setCode(event.target.value.toUpperCase())}
                maxLength={6}
                style={{
                  textAlign: "center",
                  fontSize: 30,
                  letterSpacing: "0.3em",
                  fontFamily: "ui-monospace, monospace",
                }}
              />
            </div>
            <button className="btn btn--accent btn--block" type="submit" disabled={code.length < 6}>
              Connect
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
